import { InlineInfoBox } from "staysure-component-library";

import RichText from "@/components/atoms/rich-text/rich-text";
import { APPLICATION } from "@/constants";

import { useContactDetailsContext } from "../../../../provider/contact-details.provider";
import { formCmsData } from "../../../../utils/contact-details-page.util";
import Styles from "../../contact-form-content.module.css";

function ContactDetailsInfoBoxSection() {
  const { cmsData } = useContactDetailsContext();
  const { renewalNonEditInfoBox } = formCmsData(cmsData);

  return (
    APPLICATION === "renewal" &&
    renewalNonEditInfoBox && (
      <div className="mt-spacing-s  w-full">
        <InlineInfoBox
          tabIndex={-1}
          className={`px-spacing-m py-spacing-xs w-full font-body-font font-normal
                          text-2xs text-text-functional-1 rounded-lg border !border-border-select
                          mt-spacing-s mb-0 mx-auto leading-spacing-l bg-surface-info-2 ${Styles.infoBox}`}
          content={<RichText richText={renewalNonEditInfoBox} />}
        />
      </div>
    )
  );
}
export default ContactDetailsInfoBoxSection;
